module.exports = __webpack_public_path__ + "static/media/icon_exclamation-gray.7fb8ad0a.svg";